import { CREDIT_CARD_ERRORS } from '@themenu/ui'

export const creditCardNeedsAuthentication = card =>
  (card &&
    card.errorCodes.includes(CREDIT_CARD_ERRORS.AUTHENTICATION_REQUIRED)) ||
  false
